export default "__VITE_ASSET__KX6etegq__"